import lbaHelpIconCtrl from './lbaHelpIconCtrl';
import lbaHelpIconDir from './lbaHelpIconDir';

export default angular.module('lbaHelpIcon', [])
  .controller('lbaHelpIconCtrl', lbaHelpIconCtrl)
  .directive('lbaHelpIcon', lbaHelpIconDir); 


// WEBPACK FOOTER //
// ./src/components/lbaHelpIcon/index.js